import { LockRepository, hasLock, keyify, delay } from './index';

/**
 * updateLock alters an existing lock on the held locks array.
 */
export const updateLock = ({commit, state}, payload) => {
  const index = state.locks.findIndex(l => l.key === payload.key);
  if (index < 0) {
    return;
  }

  const lock = {
    ...state.locks[index],
    ...payload,
  };

  commit('setLock', lock);
};

/**
 * openLock creates a new lock on the given resource.
 */
export const openLock = async ({commit, dispatch}, {key}) => {
  key = keyify(key);
  commit('addLock', {key});

  try {
    const data = await LockRepository.lock(key);
    dispatch('updateLock', {
      key: key,
      lock: data,
      error: '',
    });
  } catch (err) {
    if (err.response && err.response.status === 409) {
      dispatch('updateLock', {
        key: key,
        error: err.response.data.message,
      });
  
      const second = 1000;
      await delay(10 * second);
      return dispatch('openLock', {key});
    }

    throw err;
  }

  dispatch('pollLock', key);
};

/**
 * releaseLock clears a lock from the given store.
 */
export const releaseLock = async ({commit, state}, {key}) => {
  key = keyify(key);
  if (!hasLock(state.locks, key)) {
    return;
  }

  commit('removeLock', key);
  await LockRepository.release(key);
};

/**
 * pollLock maintains an open lock via polling.
 */
export const pollLock = async ({dispatch, state}, key) => {
  key = keyify(key);
  
  const second = 1000;
  await delay(30 * second);
  if (!hasLock(state.locks, key)) {
    return;
  }
  
  try {
    const data = await LockRepository.refresh(key);
    dispatch('updateLock', {
      key: key,
      lock: data,
      error: '',
    });
  } catch (err) {
    if (err.response && err.response.status === 409) {
      dispatch('updateLock', {
        key: key,
        error: err.response.data.errors,
      });

      const second = 1000;
      await delay(60 * second);
      return dispatch('openLock', {key});
    }

    throw err;
  }

  dispatch('pollLock', key);
};
